function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.556 1H2.444C1.647 1 1 1.647 1 2.444v10.112C1 13.353 1.647 14 2.444 14h10.112c.797 0 1.444-.647 1.444-1.444V2.444C14 1.647 13.353 1 12.556 1z",
  stroke: "#fff",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.656 5.875a1.219 1.219 0 100-2.437 1.219 1.219 0 000 2.437z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 9.125l-3.809-4.063L1.812 14",
  stroke: "#fff",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));